import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    Auth.exchange(sid)
      .then((user) => {
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || "Auth failed");
      });
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="brutal-border brutal-shadow bg-white p-8 text-center">
        <div className="font-display text-3xl mb-2">Signing you in…</div>
        <div className="text-sm text-neutral-700">{error || "One moment please…"}</div>
      </div>
    </div>
  );
}
